import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import { useSoftUIController } from "context";

import { getData } from "Utils/server";
import { getAuthorizationHeader } from "Utils/helpers";

function AvailableTemplates({ setParentSelectedType }) {
  const [controller, dispatch] = useSoftUIController();
  const { platform } = controller;
  const [selectedOption, setSelectedOption] = useState("both");
  const [options, setOptions] = useState([]);

  const handleTypeSelect = (selectedItem) => {
    setSelectedOption(selectedItem.value);
    setParentSelectedType(selectedItem);
  };

  const initData = async () => {
    let selectedPlatformId = platform.value;
    let getTemplatesEndpoint = `/api/v1/platforms/${selectedPlatformId}/templates-list`;
    let response = await getData(getTemplatesEndpoint, { Authorization: getAuthorizationHeader() });
    if (response != null) {
      response.data.map((el) => {
        el.template = el.name;
        el.tpl_providers = el.providers_count ? `${el.providers_count} Providers, ` : "";
        el.tpl_sports = el.sports_count ? `${el.sports_count} Sports, ` : "";
        el.tpl_competitions = el.competitions_count ? `${el.competitions_count} Competitions` : "";
        el.filters = `${el.tpl_providers}${el.tpl_sports}${el.tpl_competitions}`;
        el.status = el.status ? "Enabled" : "Disabled";
      });
      let options = [];
      response.data.forEach((template) => {
        options.push({ value: template.id, label: template.name });
      });

      setOptions(options);
    }
  };

  useEffect(() => {
    initData();
  }, [platform.label]);

  return (
    <>
      <Grid
        container
        spacing={12}
        item
        xs={12}
        md={12}
        style={{ minHeight: "285px", paddingTop: "40px" }}
      >
        <Grid item xs={12} md={12}>
          <SoftBox mb={1}>
            <SoftTypography variant="h5" fontWeight="regular" style={{ textAlign: "center" }}>
              Before Continue ...
            </SoftTypography>
          </SoftBox>
        </Grid>
        <Grid item xs={3} md={3} style={{ paddingTop: "0px" }}></Grid>
        <Grid item xs={6} md={6} style={{ paddingTop: "0px" }}>
          <SoftTypography variant="body2" fontWeight="regular" color="text">
            Please Select in which Template you want to Create a new Filter
          </SoftTypography>
          <SoftSelect
            defaultValue={selectedOption}
            options={options}
            onChange={handleTypeSelect}
            size="small"
          />
        </Grid>
        <Grid item xs={3} md={3} style={{ paddingTop: "0px" }}></Grid>
      </Grid>
    </>
  );
}

// Typechecking props of the CreateTemplate
AvailableTemplates.propTypes = {
  setParentSelectedType: PropTypes.func,
};

export default AvailableTemplates;
